import { useMutation, useQuery, useQueryClient } from "react-query";
import { useToasts } from "react-toast-notifications";

import {
	approveAppOrder,
	deleteAppOrder,
	getCreate,
	getList,
	rejectAppOrder,
	saveAppOrder,
	finishAppOrder,
	duplicateAppOrder,
	returnStateAppOrder,
	checkStatusAppOrder,
	getCodeCreate,
} from "@/api/ApplicationOrders/applicationOrders";

const key = "application_orders";

export function useApplicationOrdersPaginate(base) {
	return useQuery([key, { ...base }], () => getList(base), {
		keepPreviousData: true,
	});
}

export function useAppOrderCreate(params) {
	return useQuery([key, { ...params }], () => getCreate(params), {});
}

export function useAppOrderCodeCreate(estate_parent_id, application_order_id) {
	return useQuery([key + "_code", { estate_parent_id, application_order_id }], () => getCodeCreate({ estate_parent_id, application_order_id }), {
		enabled: !!estate_parent_id && !application_order_id,
	});
}

export function useAppOrderSave(base, params) {
	const queryClient = useQueryClient();
	return useMutation(saveAppOrder, {
		onSuccess: (response) => {
			if (response?.list) {
				queryClient.setQueryData([key, { ...base }], response);
			}
			if (params) {
				queryClient.setQueryData([key, { ...params }], (old) => {
					if (!old) return old;
					return { ...old, app_order: response.app_order };
				});
			}
		},
	});
}

export function useAppOrderDuplicate(base, _params) {
	const { addToast } = useToasts();
	const queryClient = useQueryClient();

	return useMutation(duplicateAppOrder, {
		onSuccess: (response) => {
			addToast("Orden de aplicación duplicada correctamente", {
				appearance: "success",
			});
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}

export function useAppOrderReturnState(base, _params) {
	const queryClient = useQueryClient();

	return useMutation(returnStateAppOrder, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}

export function useAppOrderCheckStatus(base, _params) {
	const queryClient = useQueryClient();

	return useMutation(checkStatusAppOrder, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}

export function useAppOrderDelete(base, _params) {
	const { addToast } = useToasts();
	const queryClient = useQueryClient();

	return useMutation(deleteAppOrder, {
		onSuccess: (response) => {
			addToast("Orden de aplicación eliminada correctamente", {
				appearance: "success",
			});
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}

export function useAppOrderApprove(base, _params) {
	const queryClient = useQueryClient();
	return useMutation(approveAppOrder, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}

export function useAppOrderReject(base, _params) {
	const queryClient = useQueryClient();

	return useMutation(rejectAppOrder, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}

export function useAppOrderFinish(base, _params) {
	const queryClient = useQueryClient();

	return useMutation(finishAppOrder, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, { ...base }], response);
		},
	});
}
